import { AutoFixIcon } from './AutoFixIcon';

/**
 * author: Google
 * id FAAFAACC-4E0D-4688-B583-FC88A782A9B6
 * name auto-fix
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/auto-fix.svg
 * tags
 * - Photography 
 */
export const MagicIcon = AutoFixIcon;
export default MagicIcon